import { FormSlot } from '@formily/react-schema-renderer';
export { FormSlot };
export default FormSlot;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/form-slot/index.js
// module id = 6303
// module chunks = 0